import "../Main.css";
import axios from "axios";
import Address from "../../components/Address";
import { useEffect, useState } from "react";
import { getSubjectInfoBySolutionId, addSubject } from "../../services/SolutionDetailAPI";
import SubjectCard from "../../components/admin/solution/SubjectCard";
import { Button } from "@chakra-ui/react";
import Modal from "react-modal";
import ContentAddModal from "../../components/admin/solution/ContentAddModal";
import SubjectModifyModal from "../../components/admin/solution/SubjectModifyModal";
import { AdminMenuBar } from "../../components/admin/AdminMenuBar";
import { checkSession } from "../../services/Admin";

const AdminSolutionDetail = () => {
    const [titleImage, setTitleImage] = useState();
    const [titleText, setTitleText] = useState();
    const [currentPageId, setcurrentPageId] = useState();
    const [solutionName, setSolutionName] = useState();
    const [subjectList, setSubjectList] = useState();
    const [subjectCardList, setSubjectCardList] = useState([]);
    const [updateState, setUpdateState] = useState();
    const [isContentAddModalOpen, setIsContentAddModalOpen] = useState(false);
    const [isSubjectModifyModalOpen, setIsSubjectModalOpen] = useState(false);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth", // 부드럽게 스크롤링되도록 설정 (선택적)
        });
    };

    useEffect(() => {
        checkSession();
        scrollToTop();
        setcurrentPageId(window.location.href.split("id=")[1]);
        axios.get("/api/solution/title").then((res) => {
            setTitleImage(res.data.imageUrl);
            setTitleText(res.data.name);
        });
    }, []);

    useEffect(() => {
        currentPageId &&
            getSubjectInfoBySolutionId(currentPageId).then((res) => {
                setSolutionName(res["solutionName"]);
                setSubjectList(res["subjectList"]);
            });
    }, [currentPageId, updateState]);

    useEffect(() => {
        let cards = [];
        subjectList &&
            subjectList.map((subject) => {
                cards.push(
                    <SubjectCard
                        key={subject.subjectID}
                        subjectID={subject.subjectID}
                        moreInfoFlag={subject.moreInfoFlag}
                        updateState={updateState}
                        setUpdateState={setUpdateState}
                        setIsContentAddModalOpen={setIsContentAddModalOpen}
                        setIsSubjectModalOpen={setIsSubjectModalOpen}
                    />
                );
            });
        setSubjectCardList(cards);
    }, [subjectList]);

    return (
        <div>
            <AdminMenuBar selected_page={4} />
            <div
                className="w-full h-[300px] bg-black text-8xl font-bold text-white flex items-center justify-center bg-[length:100%_100%]"
                style={{ backgroundImage: `url(${titleImage})` }}
            >
                {titleText}
            </div>

            <div
                style={{
                    marginLeft: "10%",
                    marginTop: "1%",
                    marginBottom: "1%",
                    fontSize: "xx-large",
                    fontWeight: "bold",
                }}
            >
                {solutionName}{" "}
                <div className="flex">
                    <Button
                        colorScheme="green"
                        fontSize="3xl"
                        px="10px"
                        py="20px"
                        onClick={() => {
                            addSubject(currentPageId, "새로운 구성요소").then(() => {
                                getSubjectInfoBySolutionId(currentPageId)
                                    .then((res) => {
                                        setSolutionName(res["solutionName"]);
                                        setSubjectList(res["subjectList"]);
                                    })
                                    .then(() => {
                                        alert("구성요소 추가가 완료되었습니다.");
                                    });
                            });
                        }}
                    >
                        구성요소 추가
                    </Button>
                    <div className="flex items-end ml-[10px]">
                        <div>
                            <div className="text-2xl">버튼을 클릭해 솔루션의 새로운 구성요소를 추가할 수 있습니다.</div>
                            <div className="text-2xl">
                                구성요소를 추가하고 [컨텐츠 추가] 버튼을 통해 알맞는 컨텐츠들을 추가해보세요.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="h-full w-full bg-white mb-10">
                <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>{subjectCardList}</div>
            </div>

            <Modal
                isOpen={isContentAddModalOpen}
                style={{
                    content: {
                        width: "400px",
                        height: "520px",
                        margin: "auto",
                        marginTop: "80px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    },
                }}
            >
                <ContentAddModal setIsModalOpen={setIsContentAddModalOpen} setUpdateState={setUpdateState} />
            </Modal>

            <Modal
                isOpen={isSubjectModifyModalOpen}
                style={{
                    content: {
                        width: "400px",
                        height: "300px",
                        margin: "auto",
                        marginTop: "10%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    },
                }}
            >
                <SubjectModifyModal setIsModalOpen={setIsSubjectModalOpen} setUpdateState={setUpdateState} />
            </Modal>
            <Address />
        </div>
    );
};

export default AdminSolutionDetail;
